/* The Rate Reset sales page: the one-client demo, the bump, and the page's events.
   The demo runs the same engine as the app (app/engine.js, app/texts.js). Nothing is stored before consent. */
(function () {
  'use strict';
  var RR = window.RateReset, TX = window.RateResetTexts;
  var $ = function (id) { return document.getElementById(id); };
  var track = function (ev, props, opt) { try { window.posthog && window.posthog.capture(ev, props || {}, opt); } catch (e) {} };

  // ---------------------------------------------------------------- header
  var top = document.querySelector('.top');
  var onScroll = function () { top && top.classList.toggle('scrolled', window.scrollY > 8); };
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  // ---------------------------------------------------------------- in-page links
  // A tap on "#offer" etc. scrolls there without writing the #section into the address bar: a shared or bookmarked
  // link opens at the top, and a refresh never jumps to a section. The CSS gives the smooth scroll and the header offset.
  if (location.hash) { try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var el = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ block: 'start' });
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (err) {}
  });

  // ---------------------------------------------------------------- demo
  var form = $('demo-form');
  var num = function (v) { var n = parseFloat(String(v).replace(/[^0-9.]/g, '')); return isFinite(n) ? n : null; };
  var biz = Object.assign(RR.defaultBusiness(), { name: '[Your business]', ownerName: '[Your name]', phone: '[your number]', payModel: 'owner' });
  var started = false, lastSent = '', sendTimer = null, storeOk = false, lastDemo = null;
  function keepDemo() {
    if (!storeOk || !lastDemo) return;
    try { localStorage.setItem('rateReset.demo', JSON.stringify(lastDemo)); } catch (err) {}
  }
  // the app (same site) offers this client after purchase; stored only once storage is allowed
  if (window.Funnel && Funnel.consent) Funnel.consent.on(function () { storeOk = true; keepDemo(); });

  function read() {
    var crew = form.querySelector('input[name=crew]:checked');
    return {
      price: num($('d-price').value), freq: $('d-freq').value, hours: num($('d-hours').value),
      crew: crew ? +crew.value : 1, drive: num($('d-drive').value), target: num($('d-target').value)
    };
  }

  function stepsText(steps) {
    var first = steps[0].from.slice(0, 4);
    var label = function (s) { return RR.shortDate(s.from) + (s.from.slice(0, 4) !== first ? ', ' + s.from.slice(0, 4) : ''); };
    if (steps.length === 1) return RR.money(steps[0].price) + ' from ' + label(steps[0]);
    var parts = steps.map(function (s) { return RR.money(s.price) + ' on ' + label(s); });
    return parts.slice(0, -1).join(', ') + ', then ' + parts[parts.length - 1];
  }

  function render() {
    var d = read();
    var out = $('demo-out');
    var ok = d.price > 0 && d.hours > 0 && d.target > 0 && d.drive != null;
    out.classList.toggle('is-empty', !ok);
    if (!ok) { $('o-gap').textContent = 'Fill in price, hours, drive and your target.'; return null; }

    biz.target = { mode: 'hourly', hourly: d.target };
    var c = RR.defaultClient({ name: '[Client]', price: d.price, freq: d.freq, hoursOnSite: d.hours, crew: d.crew, driveMin: d.drive, pay: 'card' });
    var p = RR.plan(c, biz, 0);
    var eph = p.e.earnPerHour;
    var per = d.crew > 1 ? ' a cleaner-hour' : ' an hour';

    $('o-eph').textContent = RR.money(Math.round(eph));
    $('o-eph').parentNode.lastChild.textContent = per;
    $('o-eph').parentNode.classList.toggle('ok', eph >= d.target - 0.5);
    var gap = d.target - eph;
    $('o-gap').textContent = gap > 0.5
      ? 'That’s ' + RR.money(Math.round(gap)) + per + ' below your target.'
      : 'You’re at or above your target here. This one can stay as it is.';

    $('o-target').textContent = p.target ? RR.money(p.target) : '–';
    var raised = p.steps.length > 0;
    $('o-steps').textContent = raised ? stepsText(p.steps) : 'No raise needed';
    var why = $('o-why'), short = raised && p.final < p.target;
    why.textContent = 'Raises over 20% or $30 a visit are split into dated steps. Big one-time jumps on long-time clients are where owners lose people.' +
      (short ? ' Even after these steps this client is below ' + RR.money(p.target) + ': in the app you can choose bigger steps, a lighter visit, or letting them go.' : '');
    why.hidden = !(p.steps.length > 1);

    var nerve = $('o-nerve');
    if (raised && p.e.CM > 0) {
      var a = RR.acceptNeeded(p.e.CM, p.eNew.CM, 0);
      if (a.kind === 'share') {
        var n = Math.ceil(1 / a.loss - 1e-9);
        var hours = Math.round(p.e.H * p.e.v);
        nerve.textContent = n <= 12
          ? 'If you raised ' + n + ' clients like this one and 1 of them left, you’d still come out ahead, and get about ' + hours + ' hours a year back.'
          : 'This step pays off as long as at least ' + Math.round(a.p * 100) + ' in 100 clients like this one stay.';
        nerve.hidden = false;
      } else nerve.hidden = true;
    } else if (raised) {
      nerve.textContent = 'This client costs you money at today’s price. Even if they leave over the raise, you’re not worse off.';
      nerve.hidden = false;
    } else nerve.hidden = true;

    var e = p.e, M = function (x) { return RR.money(x, true); };
    $('o-how-text').textContent = 'Price ' + M(e.P) + ', minus the card fee ' + M(e.fee) + ', gas ' + M(e.vehicle) +
      ' (' + Math.round(e.miles) + ' miles at 76¢, estimated from ' + Math.round(d.drive) + ' minutes at 30 mph) and supplies ' + M(e.supplies) +
      ' leaves ' + M(e.CM) + '. Divided by ' + (Math.round(e.H * 100) / 100) + (d.crew > 1 ? ' cleaner-hours' : ' hours') + ' (' + d.hours + (d.crew > 1 ? ' × 2' : '') +
      ' in the house + ' + Math.round(d.drive) + ' minutes driving' + (d.crew > 1 ? ' × 2' : '') + ') = ' + M(e.earnPerHour) + (d.crew > 1 ? ' a cleaner-hour.' : ' an hour.') +
      (p.pStar ? ' For ' + M(d.target) + (d.crew > 1 ? ' a cleaner-hour' : ' an hour') + ', the price is (' + M(e.C0) + ' + ' + M(d.target) + ' × ' + (Math.round(e.H * 100) / 100) + ') ÷ (1 − ' + RR.pct(e.r, 1) + ' card fee) = ' + M(p.pStar) + ', rounded up to ' + RR.money(p.target) + '.' : '');

    var box = $('o-text').parentNode;
    if (raised) { $('o-text').textContent = TX.notice(c, p, biz, { tone: 'brief' }).text; box.hidden = false; }
    else box.hidden = true;

    return { d: d, p: p };
  }

  function bucket(x, edges) { for (var i = 0; i < edges.length; i++) if (x < edges[i]) return (i ? edges[i - 1] : 0) + '-' + edges[i]; return edges[edges.length - 1] + '+'; }

  function changed() {
    var r = render();
    if (!r) return;
    if (!started) { started = true; track('demo_start'); }
    clearTimeout(sendTimer);
    sendTimer = setTimeout(function () {
      var e = r.p.e, raise = r.p.steps.length ? r.p.pNew / e.P - 1 : 0;
      var props = {
        tier: r.p.tier, steps: r.p.steps.length, crew: r.d.crew, freq: r.d.freq,
        earn_per_hour: bucket(e.earnPerHour, [20, 30, 40, 50]), first_raise_pct: bucket(raise * 100, [1, 10, 20, 40]),
        target: bucket(r.d.target, [35, 45, 55])
      };
      var key = JSON.stringify(props);
      if (key !== lastSent) { lastSent = key; track('demo_result', props); }
      lastDemo = { price: r.d.price, freq: r.d.freq, hoursOnSite: r.d.hours, crew: r.d.crew, driveMin: r.d.drive, target: r.d.target };
      keepDemo();
    }, 1200);
  }

  if (form && RR && TX) {
    form.addEventListener('input', changed);
    form.addEventListener('change', changed);
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    render();
  }

  // ---------------------------------------------------------------- bump and buy
  var buy = $('buy'), bump = $('bump-box');
  function prices() {
    var P = (window.Funnel && Funnel.products) || {};
    var main = P['the-rate-reset'], add = P['new-client-price-builder'];
    return { main: main ? main.price : null, add: add ? add.price : null };
  }
  function syncBuy() {
    if (!buy) return;
    var on = bump && bump.checked;
    // lines are sold in the order written and listed reversed at checkout: the main product shows first
    buy.setAttribute('href', on ? '/cart/' + buy.dataset.bump + ':1,' + buy.dataset.main + ':1' : '/cart/' + buy.dataset.main + ':1');
    var pr = prices();
    if (pr.main != null && window.Funnel) $('buy-total').textContent = Funnel.money(pr.main + (on && pr.add ? pr.add : 0));
  }
  if (bump) bump.addEventListener('change', function () { syncBuy(); track('bump_toggle', { on: bump.checked }); });
  syncBuy();
  if (buy) buy.addEventListener('click', function () {
    track('buy_click', { bump: !!(bump && bump.checked), demo_used: started }, { send_instantly: true, transport: 'sendBeacon' });
  });

  // ---------------------------------------------------------------- in-page buttons, sections, questions
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cta]');
    if (a) track('cta_click', { where: a.getAttribute('data-cta'), to: (a.getAttribute('href') || '').replace('#', '') });
  });
  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var s = en.target.getAttribute('data-section');
        if (en.isIntersecting && !seen[s]) { seen[s] = true; track('section_view', { section: s }); io.unobserve(en.target); }
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('[data-section]').forEach(function (el) { io.observe(el); });
  }
  document.querySelectorAll('.faq details').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) track('faq_open', { question: d.querySelector('summary').textContent.trim().slice(0, 80) }); });
  });
})();
